import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { Button, Row, Col, Modal, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { withTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { duotone, solid } from '@fortawesome/fontawesome-svg-core/import.macro';
import ChatsService from '../../controllers/ChatController';
import { closeConversationByAgent } from '../../redux/interactionsSlice';
import Toastr from '../utils/toastr';

class CloseMultipleConfirm extends Component {

    constructor(props) {
        super(props)
        this.closeChat = this.closeChat.bind(this);
        this.toastrRef = React.createRef();
    }

    closeChat() {
        let data = this.props?.conversations.map(x => x.conversationId);
        ChatsService.closeConversations({
            userId: localStorage.getItem("faUserId"),
            conversations: data,
        }, res => {
            console.log(res);
            if (res) {
                this.props.toggleModal();
            } else {
                this.toastrRef.current.setType("error");
                this.toastrRef.current.setMessage(this.props.t("error"));
                this.toastrRef.current.show();
            }
        });
    }

    render() {
        return (<>
            <Modal show={this.props.show} onHide={this.props.toggleModal} size="md" backdrop="static">
                <Modal.Header>
                    <Modal.Title><FontAwesomeIcon icon={duotone("warning")} /> {this.props.t("warning")}</Modal.Title>
                    <OverlayTrigger
                        placement="left"
                        delay={{ show: 250, hide: 400 }}
                        overlay={<Tooltip style={{ position: "fixed" }}>
                            {this.props.t("close")}
                        </Tooltip>}>
                        <Button onClick={this.props.toggleModal} className='float-end'><FontAwesomeIcon icon={solid('xmark')} /></Button>
                    </OverlayTrigger>
                </Modal.Header>
                <Modal.Body>
                    <Row>
                        <Col>
                            <p>{this.props.t("youarebouttoclosemultiplechat")}</p>
                            <p>{this.props.t("areyousure")}</p>
                        </Col>
                    </Row>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" onClick={this.closeChat}>
                        <FontAwesomeIcon icon={duotone("paper-plane-top")} /> {this.props.t("ok")}
                    </Button>
                </Modal.Footer>
            </Modal>
            <Toastr ref={this.toastrRef} />
        </>
        )
    }
}


const mapStateToProps = (state) => {
    return {
        chatUrl: state.parameters.chatUrl,
        LOADING_TYPE: state.parameters.LOADING_TYPE,
        agentName: state.agent.name,
        userId: state.agent.userId,
        showSearch: state.interaction.showSearch,
        interaction: state.interaction.current
    };
};
export default compose(connect(mapStateToProps, { closeConversationByAgent }), withTranslation())(CloseMultipleConfirm);